import { createSlice } from '@reduxjs/toolkit';
import { CertificadoResponse, getCertificados } from './certificadosActions';
 
interface InitialState {
  itemsSuccess: boolean;
  itemsData: undefined | CertificadoResponse;
  itemsLoading: boolean;
  itemsError: boolean;
 
}

const initialState: InitialState = {
  itemsSuccess: false,
  itemsData: undefined,
  itemsLoading: false,
  itemsError: false,
};

const bannersSlice = createSlice({
  name: 'certificados',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCertificados.rejected, (state: InitialState) => {
      state.itemsError = true;
      state.itemsLoading = false;
      state.itemsSuccess = false;
      state.itemsData = undefined;
    });
    builder.addCase(getCertificados.pending, (state: InitialState) => {
      state.itemsError = false;
      state.itemsLoading = true;
      state.itemsSuccess = false;
    });
    builder.addCase(getCertificados.fulfilled, (state: InitialState, action) => {
      state.itemsData = action.payload;
      state.itemsError = false;
      state.itemsLoading = false;
      state.itemsSuccess = true;
    });
   
  },
});

export default bannersSlice.reducer;
